import { render, staticRenderFns } from "./StatusCreate.vue?vue&type=template&id=3c3509ae"
import script from "./StatusCreate.vue?vue&type=script&lang=js"
export * from "./StatusCreate.vue?vue&type=script&lang=js"
import style0 from "./StatusCreate.vue?vue&type=style&index=0&id=3c3509ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports